<template>
  <div class="orderdetail">
    <div class="orderdetail__container">
      <div class="orderdetail__container--con1">
        <h3 class="orderdetail__container--con1-h3">جزيیات سفارش</h3>
        <p
          v-if="list.item"
          class="orderdetail__container--con1-p1"
          style="direction: rtl"
        >
          تاریخ : {{ list.time }}
        </p>
        <p class="orderdetail__container--con1-p2">
          {{ list.id }}
        </p>
      </div>
      <hr class="kjjk" />

      <div class="orderdetail__container--con2">
        <p>
          <span style="color: var(--shrink)"> تحویل گیرنده : </span
          >{{ list.fname }}
          {{ list.lname }}
        </p>
        <p>
          <span style="color: var(--shrink)"> شماره تماس :</span>
          {{ list.cel.toPersianDigits() }}
        </p>
        <p>
          <span style="color: var(--shrink)"> آدرس :</span>
          {{ list.priv }} , {{ list.city }} ,{{ list.add }}
        </p>
        <p v-if="list.type">
          <span style="color: var(--shrink)"> نحوه ارسال :</span>
          {{ list.type }}
        </p>
        <p v-if="list.dpp">
          <span style="color: var(--shrink)"> هزینه علی الحساب پست :</span>
          {{ list.dpp.toLocaleString("fa").toPersianDigits() }}
          تومان
        </p>
        <p v-if="list.dp">
          <span style="color: var(--shrink)"> هزینه پست :</span>
          {{ list.dp.toLocaleString("fa").toPersianDigits() }}
          تومان
        </p>
        <p v-if="list.wc">
          <span style="color: var(--shrink)">
            شارژ کیف پول بر اساس اختلاف هزینه پست :</span
          >
          {{ list.wc.toLocaleString("fa").toPersianDigits() }}
          تومان
        </p>
        <p v-if="list.wa">
          <span style="color: var(--shrink)">
            موجودی کیف پولی که در قیمت کل تاثیرگذار بوده :</span
          >
          {{ list.wa.toLocaleString("fa").toPersianDigits() }}
          تومان
        </p>

        <p v-if="list.ddd">
          <span style="color: var(--shrink)"> توضیحات :</span>
          {{ list.ddd }}
        </p>
      </div>
      <hr class="kjjk" />

      <div class="orderdetail__container--con3">
        <p>
          <span style="color: var(--shrink)"> مبلغ کل :</span>
          {{ list.pri.toLocaleString("fa").toPersianDigits() }}
        </p>
        <p v-if="list.amount">
          <span style="color: var(--shrink)"> کد تخفیف :</span>
          {{ list.amount }}
        </p>
      </div>
      <div class="orderdetail__container--con4">
        <!-- <p>مبلغ کل :</p> -->
        <div style="display: flex; flex-wrap: wrap" class="">
          <p v-if="list.baz" class="orderdetail__container--con4-p1">
            <span style="color: var(--shrink)"> بازه تحویل :</span>
            {{ list.baz }}
          </p>
          <p v-if="list.time1" class="orderdetail__container--con4-p1">
            <span style="color: var(--shrink)"> زمان پرداخت :</span>
            &lrm;{{ list.time1.toLocaleString("fa").toPersianDigits() }}
          </p>
          <p class="orderdetail__container--con4-p2">
            <span style="color: var(--shrink)"> وضعیت :</span>{{ list.sta }}
          </p>
          <p v-if="list.del" class="orderdetail__container--con4-p3">
            <span style="color: var(--shrink)"> شماره پیگیری مرسوله :</span>
            {{ list.del.toPersianDigits() }}
          </p>
          <p class="orderdetail__container--con4-p4">
            <span style="color: var(--shrink)"> سود شما از این خرید :</span>
            {{ list.prf.toLocaleString("fa").toPersianDigits() }}
          </p>
        </div>

        <div class="orderdetail__container--con4-con1">
          <div
            class="kjjjk"
            :key="(item, index)"
            v-for="(item, index) in list.order"
          >
            <router-link
              :to="{ name: 'detail', params: { id: item.product.slug } }"
            >
              <img
                :src="item.product.image"
                :alt="item.product.name"
                class="orderdetail__container--con4-con1-img"
              />
              <!-- <img :src="item.product.image" alt="" /> -->
            </router-link>
            <div class="">
              <p class="orderdetail__container--con4-con1-name">
                <font-awesome-icon icon="user-edit" />
                {{ item.product.name }}
              </p>
              <p class="orderdetail__container--con4-con1-bul">
                <font-awesome-icon icon="user-edit" />
                تعداد :
                {{ item.number.toLocaleString("fa").toPersianDigits() }}
              </p>
              <p
                v-if="item.essence"
                class="orderdetail__container--con4-con1-bul"
              >
                <font-awesome-icon icon="user-edit" />
                اسانس :
                {{ item.essence }}
              </p>
              <div
                v-if="item.color"
                class="orderdetail__container--con4-con1-col"
              >
                <!-- <font-awesome-icon icon="user-edit" /> -->
                <div
                  :style="{ background: item.color.color }"
                  class="orderdetail__container--con4-con1-col-code"
                ></div>

                <p>{{ item.color.name }}</p>
              </div>
              <p class="orderdetail__container--con4-con1-pri">
                <font-awesome-icon icon="user-edit" />
                قیمت :
                {{ item.price.toLocaleString("fa").toPersianDigits() }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: {
        wc: "",
        wa: "",
        dp: "",
        dpp: "",
        ddd: "",
        fname: "",
        lname: "",
        cel: "",
        city: "",
        add: "",
        pri: "",
        order: [],
        id: "",
        time: "",
        time1: "",
        baz: "",
        sta: "",
        priv: "",
        del: "",
        prf: "",
        amount: "",
      },
      address: [],
    };
  },
  created() {
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };

    var that = this;
    var id = localStorage.getItem("orderid");
    that.$store.state.load = true;
    $.ajax({
      url:
        that.$store.state.url +
        "api/v1/shop/invoice/detail/" +
        this.$route.params.id +
        "/",
      crossDomain: true,
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile"),
      },
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        // console.log(data);
        that.list.dpp = data.delivery_pre_price;
        that.list.dp = data.delivery_pre;
        that.list.wc = data.wallet_charge;
        that.list.wa = data.wallet_amount;

        that.list.fname = data.address.first_name;
        that.list.lname = data.address.last_name;
        that.list.priv = data.address.get_province_display;
        that.list.city = data.address.city;
        that.list.cel = data.address.cellphone;
        that.list.add = data.address.address;
        that.list.del = data.delivery_track_no;
        that.list.baz = data.get_delivery_time_display;
        that.list.type = data.get_delivery_type_display;
        that.list.sta = data.get_status_display;
        that.list.time = data.delivery_date_jalali;
        that.list.time1 = data.pay_datetime_jalali;
        that.list.ddd = data.description;
        that.list.id = data.invoice_no;
        that.list.order = data.orders;
        that.list.pri = data.total_price;
        that.list.prf = data.total_profit;

        that.list.amount = data.discount_code_amount;

        // that.list = data;
        // that.address = data.address;
      },
      error: function (request, textStatus, errorThrown) {
        if (request.status == 401) {
          that.$router.push("/login");
        } else if (request.status == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function () {
        that.$store.state.load = false;
      },
    });
  },
};
</script>
<style lang="scss" scoped>
.orderdetail {
  width: 100%;
  min-height: 100vh;
  margin-top: 7.9em;
  padding: 4em;
  @media screen and (max-width: 800px) {
    font-size: 0.8em;
    padding: 2em;
  }
  @media screen and (max-width: 500px) {
    font-size: 0.5em;
    padding: 2em;
  }
  &__container {
    width: 100%;
    min-height: 100px;
    background: var(--main-color);
    padding: 2em;
    border-radius: 5px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.13);
    display: flex;
    flex-direction: column;
    direction: rtl;
    &--con1 {
      display: flex;
      &-h3 {
        margin-left: 1em;
      }
      &-p1 {
        font-size: 0.9em;
        margin-left: 1em;
      }
    }
    &--con2 {
      //   display: flex;
      //   float: right;
      p {
        // display: block;
        margin: 1em;
      }
    }
    &--con3 {
      display: flex;
      //   float: right;
      p {
        // display: block;
        margin: 1em;
      }
    }
    &--con4 {
      margin-top: 1em;
      border: 1px solid #cfd8dc;
      border-radius: 8px;
      padding: 1em;
      display: flex;
      flex-direction: column;
      &-p1 {
        width: 100%;
        margin: 0.7em;

        // display: block;
        padding-bottom: 1em;
        border-bottom: 1px solid var(--bg-color);
      }
      &-p2 {
        width: 46%;
        // display: block;
        margin: 0.7em;
        padding-bottom: 1em;
        border-bottom: 1px solid var(--bg-color);
      }
      &-p3 {
        width: 50%;
        // display: block;
        margin: 0.7em;
        padding-bottom: 1em;
        border-bottom: 1px solid var(--bg-color);
      }
      &-p4 {
        width: 100%;
        margin: 0.7em;

        // display: block;
        padding-bottom: 1em;
        border-bottom: 1px solid var(--bg-color);
      }
      &-con1 {
        display: flex;
        flex-direction: column;
        .kjjjk {
          display: flex;
          align-items: center;
          border-bottom: 1px solid var(--bg-color);
          padding-bottom: 1em;
          margin-top: 1em;
          &:last-child {
            border: none;
          }
        }
        &-img {
          width: 150px;
          height: 150px;
          margin-left: 2em;
          @media screen and (max-width: 500px) {
            width: 80px;
            height: 80px;
          }
        }
        &-name {
          margin-bottom: 0.5em;
          margin-top: 1em;
          font-size: 0.8em;
          svg {
            margin-left: 0.5em;
          }
        }
        &-bul {
          margin-bottom: 0.5em;
          font-size: 0.8em;
          //   margin-top: 1em;
          svg {
            margin-left: 0.5em;
          }
        }
        &-pri {
          margin-bottom: 0.5em;
          font-size: 0.8em;
          //   margin-top: 1em;
          svg {
            margin-left: 0.5em;
          }
        }
        &-col {
          display: flex;
          //   justify-content: center;
          align-items: center;
          margin-bottom: 0.5em;
          font-size: 0.8em;
          //   margin-top: 1em;
          &-code {
            border-radius: 50%;
            width: 12px;
            height: 12px;
            margin-left: 0.5em;
            margin-right: 0.35em;
          }
          svg {
            margin-left: 0.5em;
          }
        }
      }
    }
  }
}
.kjjk {
  width: 100%;
  border: none;
  height: 1px;
  margin-top: 1em;
  background-color: #cfd8dc;
  margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/user/userDetail/myorderdetail.vue